import { getDigitalFingerprint } from '@/services/network/digitalFingerprint';
import { GET_DIGITAL_FINGERPRINT } from './actionTypes';
import { SET_DIGITAL_FINGERPRINT } from './mutationTypes';

export default {
  async [GET_DIGITAL_FINGERPRINT]({ commit }) {
    try {
      const result = await getDigitalFingerprint();
      commit(SET_DIGITAL_FINGERPRINT, result);
    } catch {
      commit(SET_DIGITAL_FINGERPRINT, {});
    }
  },
};
